'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import { useTranslations } from '@material-bank/i18n';
import { Bookmark, FileDown, Truck } from '@material-bank/mtag-icons';
import { useAuthenticationDialog } from '../../providers/AuthenticationDialogProvider';
import { useAuthProvider } from '../../providers/AuthProvider';
const SEEN_KEY = 'mtag:login-prompt-seen';

// Covers storage that throws (private mode, disabled site data), so the prompt
// still shows at most once per page load there.
let hasShownThisLoad = false;

// True the first time it's called in this browser session.
function claimFirstShow(): boolean {
  if (hasShownThisLoad) {
    return false;
  }
  hasShownThisLoad = true;
  try {
    if (window.sessionStorage.getItem(SEEN_KEY)) {
      return false;
    }
    window.sessionStorage.setItem(SEEN_KEY, '1');
    return true;
  } catch {
    return true;
  }
}

// Opens the sign-in sheet with what an account unlocks when a guest lands on a
// tag. Shown once per browser session, so closing it isn't followed by another.
export function LoginPrompt() {
  const $ = _c(6);
  const t = useTranslations("authentication.loginPrompt");
  const {
    status
  } = useAuthProvider();
  const {
    isOpen,
    openIfIdle
  } = useAuthenticationDialog();
  const hasDecided = useRef(false);
  let t0;
  let t1;
  if ($[0] !== isOpen || $[1] !== openIfIdle || $[2] !== status || $[3] !== t) {
    t0 = () => {
      if (hasDecided.current) {
        return;
      }
      if (isOpen) {
        hasDecided.current = true;
        return;
      }
      if (status === "loading") {
        return;
      }
      hasDecided.current = true;
      if (status !== "unauthenticated" || !claimFirstShow()) {
        return;
      }
      openIfIdle({
        title: t("title"),
        description: t("description"),
        icon: null,
        benefits: [{
          icon: <Truck size={20} strokeWidth={1.75} />,
          title: t("benefits.samples.title"),
          description: t("benefits.samples.description")
        }, {
          icon: <Bookmark size={20} strokeWidth={1.75} />,
          title: t("benefits.projects.title"),
          description: t("benefits.projects.description")
        }, {
          icon: <FileDown size={20} strokeWidth={1.75} />,
          title: t("benefits.specs.title"),
          description: t("benefits.specs.description")
        }]
      });
    };
    t1 = [status, isOpen, openIfIdle, t];
    $[0] = isOpen;
    $[1] = openIfIdle;
    $[2] = status;
    $[3] = t;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  return null;
}